export default "__VITE_ASSET__c86b7cb1__"